<template>
  <div class="event-banner" :style="bannerStyle">
    <div class="event-banner__main">
      <img
        class="event-banner__icon"
        src="@/assets/event_banner/event_banner_lb.png"
        alt=""
        aria-hidden="true"
      />
      <span v-if="dateText" class="event-banner__date">{{ dateText }}</span>
      <span v-if="activityName" class="event-banner__name" :title="activityName">{{ activityName }}</span>
      <span v-if="tag" class="event-banner__tag">{{ tag }}</span>
      <!-- 跑马灯已停用：同区域单行展示，超出省略 -->
      <!--
      <div v-if="content" ref="marquee" class="event-banner__marquee">
        <div
          :key="animationKey"
          class="event-banner__track"
          :class="{ 'is-ready': isReady }"
          :style="trackStyle"
        >
          <span
            v-for="index in renderCount"
            :key="`${animationKey}-${index}`"
            :ref="index === 1 ? 'measureText' : undefined"
            class="event-banner__content"
            :aria-hidden="index > 1 ? 'true' : undefined"
          >
            {{ content }}
          </span>
        </div>
      </div>
      -->
      <div v-if="content" class="event-banner__marquee" :title="content">
        <span class="event-banner__content">{{ content }}</span>
      </div>
    </div>
    <div class="event-banner__actions">
      <button type="button" class="event-banner__detail" @click="$emit('detail')">
        {{ $t(detailText) }}
      </button>
      <button
        v-if="showRegister"
        type="button"
        class="event-banner__detail"
        :disabled="registering"
        @click="$emit('register')"
      >
        {{ $t('报名') }}
      </button>
    </div>
  </div>
</template>

<script>
  /** 默认浅蓝背景（设计稿） */
  const DEFAULT_BG = '#EDF2FF'

  export default {
    name: 'EventBanner',
    props: {
      /** 活动时间，如 1月17日-1月29日 */
      dateText: {
        type: String,
        default: '',
      },
      /** 活动名称 */
      activityName: {
        type: String,
        default: '',
      },
      /** 标签，如满100减10 */
      tag: {
        type: String,
        default: '',
      },
      /** 活动内容文案（单行省略，超出显示省略号） */
      content: {
        type: String,
        default: '',
      },
      /** 可选覆盖背景；默认 #EDF2FF */
      gradient: {
        type: String,
        default: '',
      },
      detailText: {
        type: String,
        default: '查看详情',
      },
      /** 报名门店、本店未报名、活动未结束时展示 */
      showRegister: {
        type: Boolean,
        default: false,
      },
      /** 报名请求进行中 */
      registering: {
        type: Boolean,
        default: false,
      },
      /** 跑马灯完整滚过一段文案的时长（秒）；跑马灯停用后暂未使用 */
      speed: {
        type: Number,
        default: 0,
      },
    },
    computed: {
      bannerStyle() {
        return {
          background: this.gradient || DEFAULT_BG,
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .event-banner {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    height: $mg-layout-event-banner-height;
    padding: 0 16px;
    box-sizing: border-box;
    overflow: hidden;
    z-index: 11;
    background: #edf2ff;
  }

  .event-banner__main {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
  }

  .event-banner__icon {
    flex-shrink: 0;
    display: block;
    width: 18px;
    height: 18px;
    object-fit: contain;
  }

  .event-banner__date {
    flex-shrink: 0;
    margin-left: 4px;
    color: #333;
    font-size: 16px;
    font-weight: 700;
    white-space: nowrap;
  }

  /* 可收缩：空间不够时变窄并省略 */
  .event-banner__name {
    flex: 0 1 auto;
    min-width: 0;
    margin-left: 8px;
    color: #333;
    font-size: 16px;
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .event-banner__tag {
    flex-shrink: 0;
    margin-left: 4px;
    height: 22px;
    padding: 0 8px;
    border-radius: 4px;
    background: #FF0000;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    white-space: nowrap;
  }

  /* 可伸长占满剩余空间，不低于屏宽 50%；单行超出省略 */
  .event-banner__marquee {
    flex: 1 0 50vw;
    min-width: 50vw;
    margin-left: 13px;
    margin-right: 12px;
    overflow: hidden;
  }

  .event-banner__content {
    display: block;
    width: 100%;
    color: #333;
    font-size: 16px;
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .event-banner__actions {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .event-banner__detail {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 28px;
    padding: 0 12px;
    border: 1px solid #5b8def;
    border-radius: 4px;
    background: #fff;
    color: #5b8def;
    font-size: 13px;
    cursor: pointer;
    white-space: nowrap;

    &:hover:not(:disabled) {
      background: rgba(91, 141, 239, 0.08);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
</style>
